import { ApplicationRef, ComponentRef, EmbeddedViewRef, EnvironmentInjector, Inject, Injectable, createComponent } from '@angular/core';
import { SnackbarComponent } from '../components/zen-snackbar/zen-snackbar.component';
import { SnackbarConfig } from '../models/zen-snackbar.model';
import { Subject } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  /**
    * Variable which is acess the Reference for snackbar component
    */
  componentRef: ComponentRef<SnackbarComponent> | null = null;
  /**
   * Variable which is used for snackbar Visible
   */
  isSnackbarVisible = false;
  /**
   * Creates a Subject to handle snackbar close events.
   */
  snackbarClose = new Subject<Boolean>();

  /**  
   * @param appRef To acess the Application reference
   * @param environmentInjector To acess the Environment injector
   */
  constructor(
    private appRef: ApplicationRef,
    private environmentInjector: EnvironmentInjector,
    @Inject(DOCUMENT) private document: Document
  ) { }
  /**
  * Method is used to show the snack bar
  * @param snackBarData defines snack bar data
   */
  showSnackBar(snackBarData: SnackbarConfig): any {
    if (this.isSnackbarVisible) {
      this.hideSnackBar()
      return this.createSnackBarComponent(snackBarData)
    }
    else {
      this.isSnackbarVisible = true
      return this.createSnackBarComponent(snackBarData)
    }

  }
  snackbarTimeOut(snackBarData: SnackbarConfig) {
    if (snackBarData && snackBarData.message && !snackBarData.defaultShow) {
      setTimeout(() => {
        this.hideSnackBar();
      }, snackBarData.message && snackBarData.durationTime ? snackBarData.durationTime * 1000 : 5000);
    }
  }
  /**
   * Method is used to hide the snack bar
   */
  hideSnackBar() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.snackbarClose.next(true);
      const domSnack=(this.componentRef.hostView as EmbeddedViewRef<SnackbarComponent>)
      const zensnackElement=domSnack.rootNodes.find(node => node.nodeName === 'ZEN-SNACKBAR') as HTMLElement
      if (document.body.contains(zensnackElement)) {
        document.body.removeChild(zensnackElement);
      }
      this.componentRef.destroy();
      this.componentRef = null
    }
  }
  /**
   * Method is used to create component dynamically
   * @param snackBarData defines snack bar data
   */
  createSnackBarComponent(snackBarData: SnackbarConfig) {
    this.componentRef = createComponent(SnackbarComponent, {
      environmentInjector: this.environmentInjector,
    });
    this.snackbarTimeOut(snackBarData)
    this.componentRef.instance.snackBarData = snackBarData;
    this.appRef.attachView(this.componentRef.hostView);
    const domSnack = (this.componentRef.hostView as EmbeddedViewRef<SnackbarComponent>)
    const zensnackElement = domSnack.rootNodes.find(node => node.nodeName === 'ZEN-SNACKBAR') as HTMLElement
    zensnackElement && this.document.body.appendChild(zensnackElement);
    return this.componentRef.instance.closeSnack
  }
}
